import React, { useState, useEffect } from "react";
import "./ContactPage.css";
import AlternateEmailSharpIcon from '@mui/icons-material/AlternateEmailSharp';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';
import LocalPhoneSharpIcon from '@mui/icons-material/LocalPhoneSharp';
import SupportAgentSharpIcon from '@mui/icons-material/SupportAgentSharp';

const ContactPage = () => {
  const [address, setAddress] = useState("");

  const handleAddressChange = (e) => {
    
  };


  useEffect(() => {
   setAddress("601 S TYRON STREET SUITE 100 CHARLOTTE, NC 28202 USA");
  }, []);

  const mapSrc = address
    ? `https://www.google.com/maps/embed/v1/place?key=AIzaSyAOVYRIgupAurZup5y1PRh8Ismb1A3lLao&q=${encodeURIComponent(
        address
      )}`
    : `https://www.google.com/maps/embed/v1/view?key=AIzaSyAOVYRIgupAurZup5y1PRh8Ismb1A3lLao&center=0,0&zoom=1`;

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1 className="contact-title">Contact Us</h1>
        <div className="contact-section">
          <div className="contact-card">
            <p style={{margin:"2rem"}}>
                <SupportAgentSharpIcon/>
                support services</p>
            <p>Our support specialists are happy to answer any questions you may have</p>

            <h2><AlternateEmailSharpIcon/></h2>
            <p>support@equitradezone.com</p>
          </div>
          <div className="contact-card">
            <h2>Phone</h2>
            <p>Reach us by phone or mail if you need a quick-advice on general questions</p>
            <p style={{marginTop:"1rem"}}><LocalPhoneSharpIcon/>  +1 (607) 202-9074</p>
          </div>
          <div className="contact-card">
            <h2>Find Us  </h2> <LocationOnSharpIcon/>
            <p style={{marginTop:".4rem"}}>601 S TYRON STREET SUITE 100 CHARLOTTE, NC 28202 USA</p>
            {/* <input
              type="text"
              placeholder="Enter your address"
              value={address}
              onChange={handleAddressChange}
            /> */}
          </div>
        </div>
        <div className="map-section">
          <iframe
            src={mapSrc}
            allowFullScreen
            title="Google Map"
            className="map"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
